/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useState } from 'react';
import { Button, Modal } from '@scuf/common';
import UtilityAccountAction from '../../../context/UtilityAccountContext/UtilityAccountActions';
import { useUtilityAccountContext } from '../../../context/UtilityAccountContext/UtilityAccountContext';
import './DeactivateIDSAccountTheme.scss';
import descriptors from '../../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
import useConnectorForPost from '../../shared/useConnectorAndDynamicProps/useConnectorForPost';
import { ICommonProps } from '../../UtilityServiceModal/IUtilityService';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { ApiContext } from '../../../context/ApiContext';
import { getNotifyInfo } from '../../shared/Utils/UtilitySettings/UtilitySettingsUtils';

export function DeactivateIDSAccount(props: ICommonProps) {
  const { bearerToken, requestContext } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const [state, dispatch] = useUtilityAccountContext();
  const {
    showDeactivateIDSModal,
    selectedUtility: { id, accountNumber }
  } = state;
  const closeModal = () => {
    dispatch(UtilityAccountAction.hideDeactivateIDSModal());
    dispatch(UtilityAccountAction.resetSelectedUtilityInfo());
  };
  const [submitLoading, setSubmitLoading] = useState(false);
  const connectorConfig = {
    name: 'utility-actions-IDS'
  };
  const dataConnector = useConnectorForPost({
    connectorConfig,
    requestContext,
    bearerToken
  });
  const apiContext = useContext(ApiContext);
  const { notifyMessage } = apiContext;
  const handleYes = async () => {
    const requestBody = {
      utilityAccountId: id,
      iDSEnabled: false
    };
    setSubmitLoading(true);
    const result: IAny = await dataConnector.actions.update(
      'Activation',
      requestBody
    );
    setSubmitLoading(false);
    closeModal();
    const { notifyDescription, notifyType } = getNotifyInfo(result);
    notifyMessage && notifyMessage(t(notifyDescription), notifyType);
  };
  return (
    <Modal
      className="emaas-update-deactivate-ids"
      size="large"
      closeIcon={true}
      onClose={closeModal}
      open={showDeactivateIDSModal}
      closeOnDimmerClick={false}
    >
      <div className="deactivate-modal-header">
        {t(d.DEACTIVATEIDSACCOUNT)}?
      </div>
      <Modal.Content className="deactivate-modal-content">
        <p className="confirmation-note">
          {t(d.DEACTIVATEIDSCONFIRMATIONNOTE)} “{accountNumber}”?{' '}
        </p>
        <p className="deactivate-info-mssg">{t(d.DEACTIVATEIDSACCOUNTMSSG)}</p>
        <div className="deactivate-modal-footer">
          <Button
            type="secondary"
            content={t(d.NO)}
            onClick={closeModal}
          ></Button>
          <Button
            type="primary"
            content={t(d.YES)}
            onClick={handleYes}
            loading={submitLoading}
          ></Button>
        </div>
      </Modal.Content>
    </Modal>
  );
}
